#import "./PronunciationDetails.graphql"
query PronunciationsQuery {
  pronunciations {
    ...pronunciationDetails
  }
}
